import { render } from "./SpeedDoughnut.vue?vue&type=template&id=0f0e188a&ts=true"
import script from "./SpeedDoughnut.vue?vue&type=script&lang=ts"
export * from "./SpeedDoughnut.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"symbiosy-vue-chatjs/src/components/SpeedDoughnut.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f0e188a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f0e188a', __exports__)) {
    api.reload('0f0e188a', __exports__)
  }
  
  module.hot.accept("./SpeedDoughnut.vue?vue&type=template&id=0f0e188a&ts=true", () => {
    api.rerender('0f0e188a', render)
  })

}


export default __exports__